import styled, { css } from 'styled-components';
import theme from './grid.theme.js';

const StyledGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 16px;
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: border-box;

  ${props => props.layout === 'fixed' &&
    css `
      max-width: ${theme.breakpoints.desktop}px;
    `}

  @media (${theme.media.tabletPortraitUp}) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  @media (${theme.media.tabletLandscapeUp}) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
    column-gap: 24px;
  }
`;
const StyledGridFixedContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export { StyledGrid, StyledGridFixedContainer };
